import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { analyzeResourceInventory, analyzeResourceInventoryCurrency } from "@/api/dataAll/userSegmentationGrowth";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "playerPaymentTierHistoricalResourceInventory",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      deviceList: [{
        label: "新增账号",
        id: "user"
      }],
      paramsData: {
        dimension_kind: "user"
      },
      tableList: [],
      serverList: []
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    levelChange: function levelChange(e) {
      if (!e) {
        this.paramsData.recharge_levels = '';
      }
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      this.tableList = [];
      this.tableData = [];

      if (this.value2.length > 0) {
        this.searchData.start_time = this.value2[0];
        this.searchData.inventory_time = this.value2[1];
      }

      if (!this.paramsData.resource_id) {
        this.$message.error('请输入资源ID');
        return;
      }

      if (!this.paramsData.dimension_kind) {
        this.$message.error('请选择新增设备或新增账号');
        return;
      }

      if (this.levelItem == '1' && !this.paramsData.recharge_levels) {
        this.$message.error('请输入层级');
        return;
      }

      if (/，/.test(this.paramsData.recharge_levels)) {
        this.$message.error('请输入英文的逗号');
        return;
      }

      if (/，/.test(this.paramsData.recourceID)) {
        this.$message.error('请输入英文的逗号');
        return;
      }

      this.reqLoading = true;
      var params = {
        dimension_kind: this.paramsData.dimension_kind,
        game_id: this.searchData.game_id,
        resource_id: this.paramsData.resource_id,
        start_time: this.searchData.start_time,
        inventory_time: this.searchData.inventory_time,
        server_id: this.paramsData.server_id,
        recharge_levels: this.paramsData.recharge_levels
      }; //判断是否有货币

      var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
      var reqFn = searchCurrency.length ? analyzeResourceInventoryCurrency : analyzeResourceInventory;
      reqFn(params).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          var level_map = res.tier_config;
          _this2.tableList = []; // 先清空

          _this2.tableData = []; // 先清空
          // 创建一个包含所有列的表头

          _this2.tableList.push({
            label: _this2.searchData.start_time,
            prop: _this2.searchData.start_time,
            list: []
          });

          var firstLevelKey = Object.keys(data)[0];
          var resourceKeys = Object.keys(data[firstLevelKey].resources || {}); // 添加注册人数到表头

          _this2.tableList[0].list.push({
            label: '注册人数',
            prop: 'new_count'
          }); // 添加资源列到表头


          resourceKeys.forEach(function (key) {
            _this2.tableList[0].list.push({
              label: key,
              prop: key
            });
          });
          var levelKeys = Object.keys(data);
          levelKeys.forEach(function (levelKey) {
            var levelData = data[levelKey];
            var rowData = {}; // 直接使用prop名称作为键

            rowData['new_count'] = levelData.new_count;
            rowData['range'] = levelData.range; // 处理resources数据

            if (levelData.resources) {
              Object.keys(levelData.resources).forEach(function (resourceKey) {
                var propName = resourceKey;
                rowData[propName] = levelData.resources[resourceKey];
              });
            }

            _this2.tableData.push(rowData);
          });

          _this2.tableList.unshift({
            label: '',
            list: [{
              label: '付费金额',
              prop: 'range',
              desc: '区间范围：不包含最小值，包含最大值，例：0-6是大于0且小于或等于6'
            }]
          });
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [];
      var d = {};
      this.tableList.forEach(function (item, index) {
        item.list.forEach(function (items, indexs) {
          columns.push({
            label: indexs == 0 ? item.label : '',
            prop: items.prop
          });
          d[items.prop] = items.label;
        });
      });
      var data = JSON.parse(JSON.stringify(this.tableData));
      data.unshift(d);
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};